import React, { useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { HvGrid, HvTypography } from "@hitachivantara/uikit-react-core";

import Container from "components/layout/Container";

import WorkflowTable from "components/workflow/WorkflowTable";
import { ModuleNames, ModulePolicyTypes } from "lib/api/userSettings";
import { UserDataContext } from "lib/context/UserDataContext";
import NotFound from "components/common/NotFound";

const Workflow: React.FC = () => {
  const { t } = useTranslation("workflow");

  return (
    <Container>
      <HvGrid container>
        <HvGrid item xs={12}>
          <HvTypography variant="mTitle">{t("title")}</HvTypography>
        </HvGrid>
        <HvGrid item xs={12}>
          <WorkflowTable />
        </HvGrid>
      </HvGrid>
    </Container>
  );
};
export const WorkflowAuth: React.FC = () => {
  const { hasModulePolicy } = useContext(UserDataContext);
  const hasRight = useMemo(() => {
    return (
      hasModulePolicy(ModuleNames.core, ModulePolicyTypes.entitytypesAdmin) &&
      hasModulePolicy(ModuleNames.core, ModulePolicyTypes.usergroupsAdmin) &&
      hasModulePolicy(ModuleNames.core, ModulePolicyTypes.workflowAdmin)
    );
  }, [hasModulePolicy]);
  return (
    <>
      {hasRight ? (
        <Container noHVContainer>
          <Workflow />
        </Container>
      ) : (
        <NotFound />
      )}
    </>
  );
};
export default Workflow;
